import lsLog from './localStorage.log';
import notify from '../notify/localStorage.notify';
import parser from './localStorage.parser';

function get<T>(key: string, initialValue: T): T;

function get<T>(key: string, initialValue?: T): T | undefined;

function get<T>(key: string, initialValue?: T): T | undefined {
  try {
    const stored = window.localStorage.getItem(key);

    return parser.out(stored, initialValue);
  } catch (err) {
    lsLog.error('GET', err);

    return initialValue;
  }
}

function remove(key: string) {
  try {
    window.localStorage.removeItem(key);
    notify(key, null);

    return true;
  } catch (err) {
    lsLog.error('REMOVE', err);

    return false;
  }
}

function set<T>(key: string, value: T) {
  try {
    if (value == null) return remove(key);

    const toStore = parser.in(value);

    if (toStore == null) return false;

    window.localStorage.setItem(key, toStore);
    notify(key, toStore);

    return true;
  } catch (err) {
    lsLog.error('SET', err);

    return false;
  }
}

function createLocalStorageUtils<T>(key: string | null) {
  // handle as success, no-op for storage, but any dependant ops can still run (fe updating state)
  if (!key)
    return {
      get(initialValue?: T) {
        return initialValue;
      },
      remove() {
        return true;
      },
      set() {
        return true;
      },
    };

  return {
    get(initialValue?: T) {
      return get(key, initialValue);
    },
    remove() {
      return remove(key);
    },
    set(value: T) {
      return set(key, value);
    },
  };
}

export { createLocalStorageUtils };

const ls = {
  get,
  parser,
  remove,
  set,
};

export default ls;
